import React from "react";
import "./virtualReceptionist.scss";
import { useMediaQuery } from 'react-responsive'
import VirtualButton from "./components/virtualButton/VirtualButton";

import VIRTUAL_PHONE from "../../../../assets/VIRTUAL_PHONE.png";
import Phone_call_icon from "../../../../assets/phone_call_icon.png";
import Phone_forwarded_icon from "../../../../assets/phone_forwarded_icon.png";
import Voicemail_icon from "../../../../assets/voicemail_icon.png";

const VirtualReceptionist = () => {
  const isMobile = useMediaQuery({ maxWidth: 855 })
  const buttonList = [
    { text: "Live Receptionist to answer your calls", image: Phone_call_icon },
    { text: "Call Transfer features", image: Phone_forwarded_icon },
    { text: "Immediate Message Notification", image: Voicemail_icon },
  ];
  return (
    <div className="virtualReceptionist__section">
      <div className="virtualReceptionist__section__wrapper">
        <div className="virtualReceptionist__section__wrapper__left">
          <img src={VIRTUAL_PHONE} alt="" />
        </div>
        <div className="virtualReceptionist__section__wrapper__right">
          <h1 className="secondary__heading">
            Get your Virtual and number today!
          </h1>
          <p className="virtualReceptionist__section__wrapper__right__paragraph">
            When you choose your plan you get a new phone number and your very
            own virtual receptionist in ONE!
          </p>

          {!isMobile && buttonList.map(({ text, image }, index) => (
            <VirtualButton key={index} text={text} image={image} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default VirtualReceptionist;
